import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { Router } from '@angular/router';
import { AuthService } from '@pulse-front/core';

@Component({
  selector: 'panel-b2b-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required])
  });

  isLoading = false;
  errorMessage = '';
  logoPath = 'assets/images/logo-msla.png';

  constructor(private authService: AuthService, private router: Router) { }

  onSubmit() {
    if (this.loginForm.invalid) return;

    this.isLoading = true;
    this.errorMessage = '';

    const { email, password } = this.loginForm.value;

    this.authService.login(email!, password!).subscribe({
      next: () => {
        this.isLoading = false;
        // Redirigir al dashboard/analytics
        this.router.navigate(['/analytics']);
      },
      error: (err) => {
        console.error(err);
        this.isLoading = false;
        this.errorMessage = 'Credenciales incorrectas o error en el servidor';
      }
    });
  }
}